const appName = process.env.NEXT_PUBLIC_MGDX_APP_NAME ?? process.env.MGDX_APP_NAME;

export default appName ?? "unknown";

export const isMccmEnv = () => appName === "matsukiyococokara-yqb";
